// Module
var code = "<div class=\"toast-stack\" role=\"region\" aria-label=\"Notifications\"> <gh-toast-card *ngFor=\"let item of visible\" [item]=\"item\"></gh-toast-card> <div *ngIf=\"overflowCount > 0\" class=\"toast-overflow\" aria-live=\"polite\"> +{{ overflowCount }} more </div> </div> ";
// Exports
module.exports = code;